import axios from "axios";
import { useField, useFormikContext } from "formik";
import { useEffect, useRef, useState } from "react";

const CitySearchDropdown = ({ name, label, initialValue= "", ...props }) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
 
  const [cities, setCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(initialValue);
  const [selectedCity, setSelectedCity] = useState(null);
 
  const dropdownRef = useRef(null);
 
  useEffect(() => {
   const fetchCities = async () => {
    setIsLoading(true);
    try {
     const response = await axios.get(`${process.env.REACT_APP_API_URL}cities/showallcities`);
     setCities(response.data);
    } catch (error) {
     console.error('Error fetching cities:', error);
    } finally {
     setIsLoading(false);
    }
   };
 
   fetchCities();
  }, []);
 
  useEffect(() => {
   if (searchTerm.trim() === '') {
    setFilteredCities(cities);
   } else {
    const filtered = cities.filter(city =>
      city.city_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredCities(filtered);
   }
  }, [searchTerm, cities]);
 
  useEffect(() => {
   const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
     setIsOpen(false);
    }
   };
 
   document.addEventListener('mousedown', handleClickOutside);
   return () => {
    document.removeEventListener('mousedown', handleClickOutside);
   };
  }, []);
 
  const handleInputChange = (e) => {
   setSearchTerm(e.target.value);
   if (!isOpen) setIsOpen(true);
 
   if (selectedCity && e.target.value !== selectedCity.city_name) {
    setSelectedCity(null);
    setFieldValue(name, '');
   }
  };
 
  const handleSelectCity = (city) => {
   setSelectedCity(city);
   setSearchTerm(city.city_name);
   setIsOpen(false);
 
   setFieldValue(name, city.city_name);
  };
 
  return (
    <div className="form-group mb-3" ref={dropdownRef}>
     {label && <label htmlFor={props.id || name} className="form-labe text-capitalize">{label} <span className="text-danger">*</span></label>}
     <div className="input-group">
      <input
        type="text"
        className={`form-control ${meta.touched && meta.error ? 'is-invalid' : ''}`}
        {...props}
        placeholder="Search for a city..."
        value={searchTerm}
        onChange={handleInputChange}
        onClick={() => setIsOpen(true)}
        autoComplete="off"
      />
     </div>
 
     {isOpen && (
       <div className="dropdown-menu w-25 show mt-1 shadow">
        {isLoading ? (
          <div className="text-center py-2">Loading cities...</div>
        ) : filteredCities.length > 0 ? (
          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
           {filteredCities.map((city) => (
             <button
               key={city.city_id}
               type="button"
               className="dropdown-item "
               onClick={() => handleSelectCity(city)}
             >
              {city.city_name}
             </button>
           ))}
          </div>
        ) : (
          <div className="text-center py-2">No cities found</div>
        )}
       </div>
     )}
 
     {meta.touched && meta.error ? (
       <div className="invalid-feedback d-block">{meta.error}</div>
     ) : null}
    </div>
  );
 };
 export default CitySearchDropdown;